// app/javascript/controllers/party_messages_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select", "email", "submit"]

    connect() {
        this.onChange() // set initial state on load/back nav
    }

    // Runs on both input/change
    onChange() {
        const hasSelect = (this.selectTarget?.value || "").trim() !== ""
        const emailVal  = (this.emailTarget?.value || "").trim()
        const hasEmail  = emailVal.length > 0

        // mutual exclusion
        this._setDisabled(this.emailTarget, hasSelect)
        if (hasSelect) this.emailTarget.value = ""

        this._setDisabled(this.selectTarget, hasEmail)
        if (hasEmail && this.selectTarget.value) this.selectTarget.value = ""
    }

    beforeSend(event) {
        // push Quill HTML to hidden field
        const quill  = window.__quillById ? window.__quillById["editor_send_message"] : null
        const hidden = document.getElementById("party_message_html")
        if (hidden) hidden.value = quill ? quill.root.innerHTML : ""

        // recipients validation
        const group      = this.selectTarget?.value || ""
        const email      = (this.emailTarget?.value || "").trim()
        const emailValid = email ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) : false

        if (!group && !emailValid) {
            event.preventDefault()
            this.flash("Please select a recipient group or enter a valid email address.")
            this._focusFirst()
            return
        }

        // body validation (existing)
        if (!hidden.value || hidden.value.replace(/<[^>]*>/g, "").trim() === "") {
            event.preventDefault()
            this.flash("Message body can’t be blank.")
            return
        }
    }

    flash(text) {
        const box = document.getElementById("ps-flash")
        if (!box) return
        box.innerHTML = `
      <div class="alert alert-warning alert-dismissible fade show" role="alert">
        ${text}
        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
      </div>`
    }

    // --- helpers ---
    _setDisabled(el, disabled) {
        if (!el) return
        el.disabled = !!disabled
        el.classList.toggle("disabled", !!disabled)
    }
    _focusFirst() {
        if (!this.emailTarget?.disabled) this.emailTarget.focus()
        else if (!this.selectTarget?.disabled) this.selectTarget.focus()
    }
}